export enum ScoreChipLevel {
  INSUFFICIENT_DATA = 'insufficient-data',
  EXCELLENT_MATCH = 'excellent-match',
  VERY_GOOD_MATCH = 'very-good-match',
  GOOD_MATCH = 'good-match',
  NO_MATCH = 'no-match',
  ERROR = 'error',
  LOADING = 'loading',
}
